import './App.css';
import Lobby from "./pages/lobby/lobby.jsx";
import DeckBuilder from "./pages/DeckBuilder/DeckBuilder";
import Game from "./pages/game/Game.jsx";

import { useEffect, useState, useRef } from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import { socket } from './utils/nakama';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  const lobbyMusic = useRef(null);

  const [currentScreen, setCurrentScreen] = useState("lobby");
  const [matchId, setMatchId] = useState("");
  const [musicVolume, setMusicVolume] = useState(0.25); // Default volume

  //op code listener
  const [opCodeData, setOpCodeData] = useState(null);

  useEffect(() => {
    // Only set the socket handler if socket is available
    if (socket) {
      socket.onmatchdata = (matchData) => {
        setOpCodeData(matchData);
      }
    }
  }, [socket]);

  // Wrapper for setCurrentScreen that uses View Transitions API
  const transitionToScreen = (newScreen) => {
    // Check if View Transitions API is supported
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        setCurrentScreen(newScreen);
      });
    } else {
      // Fallback for browsers that don't support View Transitions
      setCurrentScreen(newScreen);
    }
  };

  const LOCAL_STORAGE_MUSIC_VOLUME = 'musicVolume';

  useEffect(() => {
    const setVolumeFromLocalStorage = () => {
      try {
        const volume = localStorage.getItem(LOCAL_STORAGE_MUSIC_VOLUME);
        if (lobbyMusic.current) {
          lobbyMusic.current.volume = volume ? parseFloat(volume) / 100 : 0.25;
          setMusicVolume(volume ? parseFloat(volume) / 100 : 0.25);
        }
      } catch (error) {
        console.warn('Unable to access localStorage for music volume:', error);
        // Continue with default volume if localStorage isn't available
        if (lobbyMusic.current) {
          lobbyMusic.current.volume = 0.25;
        }
      }
    };

    setVolumeFromLocalStorage();

    const handleStorageChange = (e) => {
      if (e.key === LOCAL_STORAGE_MUSIC_VOLUME) {
        setVolumeFromLocalStorage();
      }
    };

    // Add the storage event listener
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <Router>
      <ToastContainer />
      <audio id="lobby-music" className="music" src="/bonez/sounds/bonez_game.mp3" type="audio/mpeg" ref={lobbyMusic} loop autoPlay />
      {currentScreen === "lobby" && <Lobby setMatchId={setMatchId} currentScreen={currentScreen} setCurrentScreen={transitionToScreen} opCodeData={opCodeData} setOpCodeData={setOpCodeData} musicVolume={musicVolume} />}
      {currentScreen === "deckBuilder" && <DeckBuilder matchId={matchId} setCurrentScreen={transitionToScreen} opCodeData={opCodeData} setOpCodeData={setOpCodeData} />}
      {currentScreen === "game" && <Game matchId={matchId} setCurrentScreen={transitionToScreen} opCodeData={opCodeData} setOpCodeData={setOpCodeData} />}
    </Router>
  );
}

export default App;
